import * as actionTypes from './types';

function setNewRouteLinks(state, action) {
    return {
        ...state,
        [action.meta]: [...state[action.meta] || [], ...action.payload],
    };
}

const reducerFunctions = {
    [actionTypes.SET_NEW_ROUTE_LINKS]: setNewRouteLinks,
};

export default function reducer(state = {}, action) {
    if (!reducerFunctions.hasOwnProperty(action.type)) {
        return state;
    }
    return reducerFunctions[action.type](state, action);
}
